import LabeledTrueFalse from "components/labeledInput/LabeledTrueFalse";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledTrueFalse);
